/* Superwrap theme scripts — all interactive logic for the super-* sections */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var money = function (n) { return 'HK$' + Number(Math.round(n)).toLocaleString(); };
  var on = function (el, ev, fn) { if (el) el.addEventListener(ev, fn); };

  /* ---------------- audience mode ---------------- */
  function currentMode() {
    var q = new URLSearchParams(location.search).get('mode');
    if (q === 'retail' || q === 'corporate') return q;
    try { var st = localStorage.getItem('super-mode'); if (st) return st; } catch (e) {}
    return document.body.getAttribute('data-super-default-mode') || 'retail';
  }
  function setMode(m) {
    document.body.setAttribute('data-super-mode', m);
    try { localStorage.setItem('super-mode', m); } catch (e) {}
    $$('[data-super-mode-set]').forEach(function (b) {
      b.classList.toggle('is-on', b.getAttribute('data-super-mode-set') === m);
    });
    window.scrollTo(0, 0);
    initFx();
  }

  /* ---------------- scroll effects ---------------- */
  function initFx() {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting || e.boundingClientRect.top < 0) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    $$('.reveal').forEach(function (n) {
      if (n.dataset.fx) return; n.dataset.fx = '1';
      if (n.getBoundingClientRect().top < window.innerHeight * 0.9) n.classList.add('in'); else io.observe(n);
    });
    $$('.stagger').forEach(function (h) {
      if (h.dataset.fx) return; h.dataset.fx = '1';
      requestAnimationFrame(function () { h.classList.add('in'); });
    });
    var fmt = function (v, dec, sep) { var r = dec > 0 ? v.toFixed(dec) : String(Math.round(v)); return sep ? Number(r).toLocaleString() : r; };
    var run = function (el) {
      var to = parseFloat(el.dataset.to), dec = +(el.dataset.dec || 0), sep = el.dataset.sep,
        pre = el.dataset.prefix || '', suf = el.dataset.suffix || '', dur = 1200, t0 = performance.now();
      var step = function (t) {
        var p = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - p, 3);
        el.textContent = pre + fmt(to * e, dec, sep) + suf;
        if (p < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    };
    var io2 = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { run(e.target); io2.unobserve(e.target); } });
    }, { threshold: 0.5 });
    $$('.sw-count').forEach(function (n) {
      if (n.dataset.fx) return; n.dataset.fx = '1';
      n.textContent = (n.dataset.prefix || '') + fmt(0, +(n.dataset.dec || 0), n.dataset.sep) + (n.dataset.suffix || '');
      io2.observe(n);
    });
    $$('.sw-spot').forEach(function (el) {
      if (el.dataset.fx) return; el.dataset.fx = '1';
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        el.style.setProperty('--mx', ((e.clientX - r.left) / r.width * 100) + '%');
        el.style.setProperty('--my', ((e.clientY - r.top) / r.height * 100) + '%');
      });
    });
    var wrap = $('#sw-gstage-wrap'), stage = $('#sw-gstage');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (wrap && stage && !wrap.dataset.fx && fine && !reduce) {
      wrap.dataset.fx = '1';
      wrap.addEventListener('pointermove', function (e) {
        var r = wrap.getBoundingClientRect();
        var rx = ((e.clientY - r.top) / r.height - 0.5) * -7;
        var ry = ((e.clientX - r.left) / r.width - 0.5) * 9;
        stage.style.transform = 'rotateX(' + rx.toFixed(1) + 'deg) rotateY(' + ry.toFixed(1) + 'deg)';
      });
      wrap.addEventListener('pointerleave', function () { stage.style.transform = ''; });
    }
    var prog = $('#sw-progress');
    if (prog && !prog.dataset.fx) {
      prog.dataset.fx = '1';
      window.addEventListener('scroll', function () {
        var h = document.documentElement.scrollHeight - window.innerHeight;
        prog.style.width = (h > 0 ? Math.min(100, (window.scrollY / h) * 100) : 0) + '%';
      }, { passive: true });
    }
  }

  /* ---------------- cart (Shopify AJAX) ---------------- */
  var CartUI = {
    drawer: null,
    open: function () { if (this.drawer) { this.drawer.classList.add('is-open'); this.refresh(); } },
    close: function () { if (this.drawer) this.drawer.classList.remove('is-open'); },
    refresh: function () {
      var self = this;
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { self.render(cart); })
        .catch(function () {});
    },
    render: function (cart) {
      var count = cart.item_count || 0;
      $$('[data-super-cart-count]').forEach(function (b) {
        b.textContent = count;
        b.style.display = count > 0 ? 'flex' : 'none';
      });
      if (!this.drawer) return;
      var empty = $('[data-super-cart-empty]', this.drawer);
      var filled = $('[data-super-cart-filled]', this.drawer);
      var list = $('[data-super-cart-lines]', this.drawer);
      if (empty) empty.style.display = count ? 'none' : 'flex';
      if (filled) filled.style.display = count ? 'flex' : 'none';
      var sub = $('[data-super-cart-subtotal]', this.drawer);
      if (sub) sub.textContent = money((cart.total_price || 0) / 100);
      if (!list) return;
      list.innerHTML = '';
      (cart.items || []).forEach(function (it) {
        var row = document.createElement('div');
        row.style.cssText = 'display:flex; gap:14px; align-items:center;';
        var img = it.image ? '<img src="' + it.image + '" alt="" style="width:100%;height:100%;object-fit:cover;display:block;">' : '';
        row.innerHTML =
          '<div style="width:64px;height:64px;border-radius:12px;overflow:hidden;flex:0 0 auto;background:#E9F3F4;">' + img + '</div>' +
          '<div style="flex:1;min-width:0;">' +
            '<div style="font-family:\'Outfit\',sans-serif;font-weight:600;font-size:14.5px;color:#16241C;">' + it.product_title + '</div>' +
            '<div style="font-size:13px;color:#7A897E;margin-top:2px;">' + money(it.final_price / 100) + '</div>' +
            '<div style="display:flex;align-items:center;margin-top:8px;border:1px solid #DEE6E8;border-radius:9px;width:fit-content;overflow:hidden;">' +
              '<button data-line="' + it.key + '" data-delta="-1" style="width:30px;height:30px;border:none;background:#fff;cursor:pointer;color:#3B848B;font-size:16px;">&minus;</button>' +
              '<span style="min-width:30px;text-align:center;font-family:\'Outfit\',sans-serif;font-weight:600;font-size:14px;color:#16241C;">' + it.quantity + '</span>' +
              '<button data-line="' + it.key + '" data-delta="1" style="width:30px;height:30px;border:none;background:#fff;cursor:pointer;color:#3B848B;font-size:16px;">+</button>' +
            '</div>' +
          '</div>' +
          '<div style="text-align:right;flex:0 0 auto;">' +
            '<div style="font-family:\'Outfit\',sans-serif;font-weight:700;font-size:14.5px;color:#16241C;">' + money(it.final_line_price / 100) + '</div>' +
            '<button data-line="' + it.key + '" data-remove="1" style="border:none;background:none;cursor:pointer;color:#A9B7BA;font-size:12px;margin-top:6px;text-decoration:underline;">Remove</button>' +
          '</div>';
        list.appendChild(row);
      });
    },
    change: function (key, qty) {
      var self = this;
      fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); }).then(function (cart) { self.render(cart); });
    },
    add: function (items, cb) {
      var self = this;
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { return r.json(); }).then(function () {
        self.open(); if (cb) cb();
      }).catch(function () { self.open(); });
    }
  };

  /* ---------------- shop carousel ---------------- */
  function initShop() {
    var scroller = $('[data-super-shop-scroller]');
    if (!scroller) return;
    var dotsWrap = $('[data-super-shop-dots]');
    var paused = false;
    scroller.addEventListener('mouseenter', function () { paused = true; });
    scroller.addEventListener('mouseleave', function () { paused = false; });
    function pages() { return Math.max(1, Math.ceil(scroller.scrollWidth / Math.max(1, scroller.clientWidth))); }
    function syncDots() {
      if (!dotsWrap) return;
      var p = pages(), max = scroller.scrollWidth - scroller.clientWidth;
      var step = p > 1 ? max / (p - 1) : 0;
      var cur = step > 0 ? Math.min(p - 1, Math.round(scroller.scrollLeft / step)) : 0;
      Array.prototype.forEach.call(dotsWrap.children, function (d, i) {
        d.style.width = i === cur ? '26px' : '8px';
        d.style.background = i === cur ? '#3B848B' : '#C9D6D9';
      });
    }
    function buildDots() {
      if (!dotsWrap) return;
      var n = pages();
      if (dotsWrap.children.length !== n) {
        dotsWrap.innerHTML = '';
        for (var i = 0; i < n; i++) {
          var b = document.createElement('button');
          b.setAttribute('aria-label', 'Go to page ' + (i + 1));
          b.style.cssText = 'width:8px;height:8px;border-radius:999px;border:none;padding:0;cursor:pointer;background:#C9D6D9;transition:width .3s ease,background .3s ease;';
          (function (idx) {
            b.addEventListener('click', function () {
              var max = scroller.scrollWidth - scroller.clientWidth, p = pages();
              scroller.scrollTo({ left: p > 1 ? idx * (max / (p - 1)) : 0, behavior: 'smooth' });
            });
          })(i);
          dotsWrap.appendChild(b);
        }
      }
      syncDots();
    }
    scroller.addEventListener('scroll', syncDots, { passive: true });
    window.addEventListener('resize', buildDots);
    buildDots();
    setInterval(function () {
      if (paused) return;
      var max = scroller.scrollWidth - scroller.clientWidth;
      if (max <= 8) return;
      if (scroller.scrollLeft >= max - 8) scroller.scrollTo({ left: 0, behavior: 'smooth' });
      else scroller.scrollBy({ left: 302, behavior: 'smooth' });
    }, 3200);
  }

  /* ---------------- quick view ---------------- */
  function initQuick() {
    var modal = $('#super-quick-view');
    if (!modal) return;
    $$('[data-super-quick]').forEach(function (el) {
      el.addEventListener('click', function () {
        var d = el.dataset;
        var img = $('[data-quick-img]', modal);
        if (img) { if (d.quickImg) { img.src = d.quickImg; img.style.display = 'block'; } else { img.style.display = 'none'; } }
        $('[data-quick-name]', modal).textContent = d.quickName || '';
        $('[data-quick-price]', modal).textContent = d.quickPrice || '';
        $('[data-quick-desc]', modal).textContent = d.quickDesc || '';
        var add = $('[data-quick-add]', modal);
        add.setAttribute('data-variant-id', d.variantId || '');
        $('[data-quick-add-label]', modal).textContent = 'Add to cart · ' + (d.quickPrice || '');
        modal.classList.add('is-open');
      });
    });
    $$('[data-super-quick-close]', modal).forEach(function (b) { on(b, 'click', function () { modal.classList.remove('is-open'); }); });
    modal.addEventListener('click', function (e) { if (e.target === modal) modal.classList.remove('is-open'); });
  }

  /* ---------------- batch builder ---------------- */
  function initBatch() {
    var root = $('[data-super-batch]');
    if (!root) return;
    var listPrice = parseFloat(root.getAttribute('data-list-price')) || 160;
    var state = { qty: 0, unit: 0, code: '' };
    var mixRows = $$('[data-super-mix]', root);
    function selectedTier() { return $('[data-super-tier].is-on', root); }
    function tierQty(btn) {
      if (!btn) return 0;
      if (btn.getAttribute('data-super-tier') === 'custom') {
        var inp = $('[data-super-custom-qty]', root);
        return Math.max(1, parseInt(inp && inp.value, 10) || 1);
      }
      return parseInt(btn.getAttribute('data-qty'), 10) || 0;
    }
    function unitFor(qty, btn) {
      if (btn && btn.getAttribute('data-super-tier') !== 'custom') return parseFloat(btn.getAttribute('data-unit')) || listPrice;
      var tiers = [];
      try { tiers = JSON.parse(root.getAttribute('data-custom-tiers') || '[]'); } catch (e) {}
      var unit = listPrice;
      tiers.forEach(function (x) { if (qty >= x.min) unit = x.unit; });
      return unit;
    }
    function spread(qty) {
      var n = mixRows.length || 1, base = Math.floor(qty / n), rem = qty - base * n;
      mixRows.forEach(function (row) {
        var add = rem > 0 ? 1 : 0; if (rem > 0) rem--;
        $('[data-super-mix-count]', row).textContent = base + add;
      });
    }
    function totals() {
      var btn = selectedTier();
      var qty = tierQty(btn), unit = unitFor(qty, btn);
      state.qty = qty; state.unit = unit; state.code = (btn && btn.getAttribute('data-code')) || '';
      var allocated = mixRows.reduce(function (a, row) { return a + (parseInt($('[data-super-mix-count]', row).textContent, 10) || 0); }, 0);
      var remaining = qty - allocated;
      var rEl = $('[data-super-batch-remaining]', root);
      if (rEl) {
        rEl.textContent = remaining > 0 ? remaining + ' left to allocate' : (remaining < 0 ? (-remaining) + ' over — remove some' : 'All allocated ✓');
        rEl.style.color = remaining === 0 ? '#3B848B' : (remaining < 0 ? '#B5433D' : '#7A897E');
      }
      var tot = $('[data-super-batch-total]', root);
      if (tot) tot.textContent = money(unit * allocated);
      var ok = remaining === 0 && allocated > 0;
      var addBtn = $('[data-super-batch-add]', root);
      if (addBtn) {
        addBtn.style.opacity = ok ? 1 : 0.45;
        addBtn.style.cursor = ok ? 'pointer' : 'not-allowed';
        addBtn.disabled = !ok;
      }
      var customBtn = $('[data-super-tier="custom"]', root);
      var cq = tierQty(customBtn), cu = unitFor(cq, customBtn);
      var cUnit = $('[data-super-custom-unit]', root), cSave = $('[data-super-custom-save]', root), cTot = $('[data-super-custom-total]', root);
      if (cUnit) cUnit.textContent = money(cu) + ' / wrap';
      if (cSave) cSave.textContent = 'Save ' + Math.round((1 - cu / listPrice) * 100) + '%';
      if (cTot) cTot.textContent = money(cu * cq);
    }
    $$('[data-super-tier]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        $$('[data-super-tier]', root).forEach(function (b) { b.classList.remove('is-on'); });
        btn.classList.add('is-on');
        spread(tierQty(btn));
        totals();
      });
    });
    on($('[data-super-custom-qty]', root), 'input', function () {
      var btn = $('[data-super-tier="custom"]', root);
      $$('[data-super-tier]', root).forEach(function (b) { b.classList.remove('is-on'); });
      btn.classList.add('is-on');
      spread(tierQty(btn)); totals();
    });
    mixRows.forEach(function (row) {
      var cnt = $('[data-super-mix-count]', row);
      on($('[data-super-mix-inc]', row), 'click', function () { cnt.textContent = (parseInt(cnt.textContent, 10) || 0) + 1; totals(); });
      on($('[data-super-mix-dec]', row), 'click', function () { cnt.textContent = Math.max(0, (parseInt(cnt.textContent, 10) || 0) - 1); totals(); });
    });
    on($('[data-super-batch-add]', root), 'click', function () {
      var items = [];
      mixRows.forEach(function (row) {
        var q = parseInt($('[data-super-mix-count]', row).textContent, 10) || 0;
        var vid = row.getAttribute('data-variant-id');
        if (q > 0 && vid) items.push({ id: Number(vid), quantity: q, properties: { 'Batch': state.qty + ' wraps' } });
      });
      if (!items.length) { CartUI.open(); return; }
      CartUI.add(items, function () {
        if (state.code) {
          var note = $('[data-super-batch-code-note]', root);
          if (note) {
            note.textContent = 'Batch discount code ' + state.code + ' applied at checkout.';
            note.classList.remove('super-hidden');
          }
          var link = $('[data-super-checkout]');
          if (link) link.setAttribute('href', '/discount/' + state.code + '?redirect=/checkout');
        }
      });
    });
    var initial = selectedTier() || $('[data-super-tier]', root);
    if (initial) { initial.classList.add('is-on'); spread(tierQty(initial)); }
    totals();
  }

  /* ---------------- AI engine section ---------------- */
  function initAiSection() {
    var root = $('[data-super-ai-engine]');
    if (!root) return;
    $$('[data-super-ai-tab]', root).forEach(function (tab) {
      tab.addEventListener('click', function () {
        var i = tab.getAttribute('data-super-ai-tab');
        $$('[data-super-ai-tab]', root).forEach(function (t) { t.classList.toggle('is-on', t === tab); });
        $$('[data-super-ai-panel]', root).forEach(function (p) {
          p.classList.toggle('super-hidden', p.getAttribute('data-super-ai-panel') !== i);
        });
      });
    });
    function conf() {
      var el = $('[data-super-ai-qty]', root);
      var qty = el ? (parseInt(el.value, 10) || 0) : 0;
      var cond = $('[data-super-chip="condition"].is-on', root);
      var pen = cond && /damag/i.test(cond.textContent) ? -6 : 0;
      var v = Math.min(98, 62 + Math.round(qty / 150) + pen);
      var bar = $('[data-super-ai-conf-bar]', root), val = $('[data-super-ai-conf-val]', root);
      if (bar) bar.style.width = v + '%';
      if (val) val.textContent = v + '%';
    }
    $$('[data-super-chip]', root).forEach(function (chip) {
      chip.addEventListener('click', function () {
        var g = chip.getAttribute('data-super-chip');
        $$('[data-super-chip="' + g + '"]', root).forEach(function (c) { c.classList.toggle('is-on', c === chip); });
        conf();
      });
    });
    var qtyEl = $('[data-super-ai-qty]', root);
    on(qtyEl, 'input', function () {
      var lab = $('[data-super-ai-qty-label]', root);
      if (lab) lab.textContent = qtyEl.value + ' units';
      conf();
    });
    conf();
    var ideas = $$('[data-super-rec-idea]', root);
    $$('[data-super-rec]', root).forEach(function (dot) {
      dot.addEventListener('click', function () {
        var i = dot.getAttribute('data-super-rec');
        $$('[data-super-rec]', root).forEach(function (d) { d.classList.toggle('is-on', d === dot); });
        ideas.forEach(function (p) { p.classList.toggle('super-hidden', p.getAttribute('data-super-rec-idea') !== i); });
      });
    });
  }

  /* ---------------- customizer ---------------- */
  function initCustomizer() {
    var root = $('[data-super-customizer]');
    if (!root) return;
    var st = { product: 'wrap', productName: '', color: '#A8C6C1', colorName: 'Sage', size: 'M', qty: 250, art: null, repeat: false };

    function setFill() {
      $$('[data-super-fill]', root).forEach(function (el) { el.style.background = st.color; });
      $$('[data-super-fill-border]', root).forEach(function (el) { el.style.borderColor = st.color; });
      var m = st.color.replace('#', '').match(/.{2}/g);
      var rgbTxt = m ? m.map(function (h) { return parseInt(h, 16); }).join(', ') : '';
      var cn = $('[data-super-color-readout]', root);
      if (cn) cn.textContent = st.colorName + ' · rgb(' + rgbTxt + ')';
    }
    function bump() {
      var p = $('[data-super-preview]', root);
      if (!p) return;
      p.classList.remove('sw-bump'); void p.offsetWidth; p.classList.add('sw-bump');
    }
    function setShape() {
      $$('[data-super-shape]', root).forEach(function (s) {
        s.classList.toggle('is-on', s.getAttribute('data-super-shape') === st.product);
      });
      var scale = { S: 0.82, M: 1, L: 1.16 }[st.size] || 1;
      var holder = $('[data-super-preview-scale]', root);
      if (holder) holder.style.transform = 'scale(' + scale + ')';
    }
    function caption() {
      var chip = $('[data-super-cust-product].is-on', root);
      var dims = chip ? (chip.getAttribute('data-dims-' + st.size.toLowerCase()) || '') : '';
      var el = $('[data-super-cust-caption]', root);
      if (el) el.textContent = st.productName + ' · ' + st.colorName + ' · size ' + st.size + (dims ? ' (' + dims + ')' : '');
      $$('[data-super-size]', root).forEach(function (b) {
        var d = $('[data-size-dims]', b);
        if (d && chip) d.textContent = chip.getAttribute('data-dims-' + b.getAttribute('data-super-size').toLowerCase()) || '';
      });
    }
    function steps() {
      var company = ($('[data-super-cust-company]', root) || {}).value || '';
      var email = ($('[data-super-cust-email]', root) || {}).value || '';
      var ok = company.trim().length > 0 && /^\S+@\S+\.\S+$/.test(email);
      var map = { details: ok, artwork: !!st.art, product: true, quantity: st.qty >= 100 };
      $$('[data-super-step]', root).forEach(function (s) {
        var done = map[s.getAttribute('data-super-step')];
        var bar = $('[data-step-bar]', s), tick = $('[data-step-tick]', s), lab = $('[data-step-label]', s);
        if (bar) bar.style.background = done ? '#A9DDE1' : 'rgba(255,255,255,.12)';
        if (tick) tick.style.display = done ? 'inline-flex' : 'none';
        if (lab) lab.style.color = done ? '#A9DDE1' : '#6E8376';
      });
      var tl = $('[data-super-tier-label]', root), tn = $('[data-super-tier-note]', root);
      var lbl = 'VOLUME', note = root.getAttribute('data-tier-note-volume') || '';
      if (st.qty >= 1000) { lbl = 'PARTNER'; note = root.getAttribute('data-tier-note-partner') || ''; }
      else if (st.qty >= 500) { lbl = 'WHOLESALE'; note = root.getAttribute('data-tier-note-wholesale') || ''; }
      if (tl) tl.textContent = lbl;
      if (tn) tn.textContent = note;
    }
    function syncHidden() {
      var set = function (n, v) { var el = $('[data-super-cust-field="' + n + '"]', root); if (el) el.value = v; };
      set('product', st.productName);
      set('colour', st.colorName + ' (' + st.color + ')');
      set('size', st.size);
      set('quantity', st.qty);
    }
    function artLayers() {
      $$('[data-super-art-single]', root).forEach(function (img) {
        if (st.art && !st.repeat) { img.src = st.art; img.style.display = 'block'; } else { img.style.display = 'none'; }
      });
      $$('[data-super-art-repeat]', root).forEach(function (layer) {
        if (st.art && st.repeat) {
          layer.style.display = 'block';
          layer.style.backgroundImage = 'url(' + st.art + '), url(' + st.art + ')';
          var size = layer.getAttribute('data-tile') || '33% 33%';
          layer.style.backgroundSize = size + ', ' + size;
          var parts = size.split(' ');
          layer.style.backgroundPosition = '0 0, ' + (parseFloat(parts[0]) / 2) + '% ' + (parseFloat(parts[1] || parts[0]) / 2) + '%';
        } else { layer.style.display = 'none'; }
      });
      $$('[data-super-art-empty]', root).forEach(function (n) { n.style.display = st.art ? 'none' : 'block'; });
    }
    $$('[data-super-cust-product]', root).forEach(function (chip) {
      chip.addEventListener('click', function () {
        $$('[data-super-cust-product]', root).forEach(function (c) { c.classList.toggle('is-on', c === chip); });
        st.product = chip.getAttribute('data-super-cust-product');
        st.productName = chip.getAttribute('data-name') || chip.textContent.trim();
        var other = $('[data-super-cust-other-field]', root);
        if (other) other.classList.toggle('super-hidden', st.product !== 'custom');
        setShape(); caption(); syncHidden(); bump();
      });
    });
    $$('[data-super-ready]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        $$('[data-super-ready]', root).forEach(function (x) { x.classList.toggle('is-on', x === b); });
        var up = $('[data-super-design-upload]', root);
        if (up) up.classList.toggle('super-hidden', b.getAttribute('data-super-ready') !== 'yes');
        var f = $('[data-super-cust-field="ready_design"]', root);
        if (f) f.value = b.getAttribute('data-super-ready') === 'yes' ? 'Yes' : 'Not yet';
      });
    });
    on($('[data-super-design-file]', root), 'change', function (e) {
      var f = e.target.files && e.target.files[0];
      var lab = $('[data-super-design-label]', root);
      if (f && lab) lab.textContent = 'Uploaded: ' + f.name;
      var hid = $('[data-super-cust-field="design_file"]', root);
      if (hid && f) hid.value = f.name;
    });
    $$('[data-super-color]', root).forEach(function (sw) {
      sw.addEventListener('click', function () {
        $$('[data-super-color]', root).forEach(function (x) { x.style.borderColor = '#DEE6E8'; });
        var cc = $('[data-super-color-custom-ring]', root);
        if (cc) cc.style.borderColor = '#DEE6E8';
        sw.style.borderColor = '#3B848B';
        st.color = sw.getAttribute('data-hex'); st.colorName = sw.getAttribute('data-name');
        setFill(); caption(); syncHidden(); bump();
      });
    });
    on($('[data-super-color-custom]', root), 'input', function (e) {
      $$('[data-super-color]', root).forEach(function (x) { x.style.borderColor = '#DEE6E8'; });
      var cc = $('[data-super-color-custom-ring]', root);
      if (cc) cc.style.borderColor = '#3B848B';
      st.color = e.target.value; st.colorName = 'Custom';
      setFill(); caption(); syncHidden();
    });
    $$('[data-super-size]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        $$('[data-super-size]', root).forEach(function (x) { x.classList.toggle('is-on', x === b); });
        st.size = b.getAttribute('data-super-size');
        setShape(); caption(); steps(); syncHidden(); bump();
      });
    });
    function qtyRender() {
      $$('[data-super-qty-val]', root).forEach(function (el) { el.textContent = st.qty; });
      steps(); syncHidden();
    }
    on($('[data-super-qty-inc]', root), 'click', function () { st.qty = Math.min(100000, st.qty + 50); qtyRender(); });
    on($('[data-super-qty-dec]', root), 'click', function () { st.qty = Math.max(100, st.qty - 50); qtyRender(); });
    on($('[data-super-art]', root), 'change', function (e) {
      var f = e.target.files && e.target.files[0];
      if (!f) return;
      var r = new FileReader();
      r.onload = function () {
        st.art = r.result;
        var lab = $('[data-super-art-label]', root), hint = $('[data-super-art-hint]', root);
        if (lab) lab.textContent = 'Artwork uploaded ✓';
        if (hint) hint.textContent = f.name;
        var rep = $('[data-super-repeat-row]', root);
        if (rep) rep.classList.remove('super-hidden');
        var hid = $('[data-super-cust-field="artwork_file"]', root);
        if (hid) hid.value = f.name;
        artLayers(); bump();
      };
      r.readAsDataURL(f);
    });
    on($('[data-super-repeat]', root), 'change', function (e) { st.repeat = e.target.checked; artLayers(); });
    $$('[data-super-cust-company], [data-super-cust-email]', root).forEach(function (i) { on(i, 'input', steps); });

    var firstChip = $('[data-super-cust-product].is-on', root) || $('[data-super-cust-product]', root);
    if (firstChip) firstChip.click();
    var firstColor = $('[data-super-color]', root);
    if (firstColor) firstColor.click();
    var defSize = $('[data-super-size="M"]', root) || $('[data-super-size]', root);
    if (defSize) defSize.click();
    st.qty = parseInt(root.getAttribute('data-default-qty'), 10) || 250;
    qtyRender(); artLayers();
  }

  /* ---------------- workshops timeline ---------------- */
  function initRunFlow() {
    var root = $('[data-super-runflow]');
    if (!root) return;
    var steps = $$('[data-super-run-step]', root);
    steps.forEach(function (s, i) {
      s.addEventListener('click', function () {
        steps.forEach(function (x, j) {
          var isOn = j === i, before = j <= i;
          var dot = $('[data-run-dot]', x), time = $('[data-run-time]', x), lab = $('[data-run-label]', x);
          if (dot) { dot.style.background = before ? '#3B848B' : '#D0DDE0'; dot.style.boxShadow = '0 0 0 1.5px ' + (before ? '#3B848B' : '#D0DDE0'); }
          if (time) time.style.color = isOn ? '#3B848B' : '#A3AFA4';
          if (lab) lab.style.color = isOn ? '#0F2416' : '#8B9A8D';
        });
        var fill = $('[data-super-run-fill]', root);
        if (fill) fill.style.width = ((i + 1) / steps.length * 100) + '%';
        var num = $('[data-super-run-num]', root), cap = $('[data-super-run-caption]', root);
        if (num) num.textContent = s.getAttribute('data-num');
        if (cap) cap.textContent = s.getAttribute('data-caption');
      });
    });
    if (steps[0]) steps[0].click();
  }

  /* ---------------- modals (workshop / AI) ---------------- */
  function initModals() {
    function bind(modalId, openSel) {
      var modal = $(modalId);
      if (!modal) return;
      $$(openSel).forEach(function (b) {
        b.addEventListener('click', function () {
          modal.classList.add('is-open');
          var type = b.getAttribute('data-type');
          if (type) {
            var chip = $('[data-super-w-type="' + type + '"]', modal);
            if (chip) chip.click();
          }
        });
      });
      $$('[data-super-modal-close]', modal).forEach(function (c) { on(c, 'click', function () { modal.classList.remove('is-open'); }); });
      modal.addEventListener('click', function (e) { if (e.target === modal) modal.classList.remove('is-open'); });
    }
    bind('#super-workshop-modal', '[data-super-workshop-open]');
    bind('#super-ai-modal', '[data-super-ai-open]');

    var wm = $('#super-workshop-modal');
    if (wm) {
      $$('[data-super-w-type]', wm).forEach(function (chip) {
        chip.addEventListener('click', function () {
          var t = chip.getAttribute('data-super-w-type');
          $$('[data-super-w-type]', wm).forEach(function (c) { c.classList.toggle('is-on', c === chip); });
          $$('[data-super-w-bullets]', wm).forEach(function (b) { b.classList.toggle('super-hidden', b.getAttribute('data-super-w-bullets') !== t); });
          var hid = $('[data-super-w-field="format"]', wm);
          if (hid) hid.value = chip.getAttribute('data-label') || t;
        });
      });
      var partVal = $('[data-super-part-val]', wm), partInput = $('[data-super-w-field="participants"]', wm);
      var setPart = function (n) { if (partVal) partVal.textContent = n; if (partInput) partInput.value = n; };
      on($('[data-super-part-inc]', wm), 'click', function () { setPart(Math.min(500, (parseInt(partVal.textContent, 10) || 20) + 5)); });
      on($('[data-super-part-dec]', wm), 'click', function () { setPart(Math.max(5, (parseInt(partVal.textContent, 10) || 20) - 5)); });
      var firstType = $('[data-super-w-type]', wm);
      if (firstType) firstType.click();
      setPart(parseInt((partVal || {}).textContent, 10) || 20);
    }

    $$('[data-super-formbody] form').forEach(function (f) {
      var wrap = f.closest('[data-super-formbody]');
      f.addEventListener('submit', function () {
        try { sessionStorage.setItem('super-form-sent', wrap.getAttribute('data-super-formbody')); } catch (e) {}
      });
    });
    var params = new URLSearchParams(location.search);
    if (params.get('contact_posted') === 'true') {
      var which = '';
      try { which = sessionStorage.getItem('super-form-sent') || ''; sessionStorage.removeItem('super-form-sent'); } catch (e) {}
      var target = which ? $('[data-super-success="' + which + '"]') : null;
      if (target) {
        target.classList.remove('super-hidden');
        var body = $('[data-super-formbody="' + which + '"]');
        if (body) body.classList.add('super-hidden');
        var modal = target.closest('.sw-overlay');
        if (modal) modal.classList.add('is-open');
      }
    }
  }

  /* ---------------- transformation game ---------------- */
  function initGame() {
    var root = $('[data-super-game]');
    if (!root) return;
    var stage = $('#sw-gstage', root);
    if (!stage) return;
    var data = { fabrics: {} };
    var holder = $('[data-super-game-data]', root);
    if (holder) { try { data = JSON.parse(holder.textContent); } catch (e) {} }
    var state = { fabric: Object.keys(data.fabrics || {})[0], product: 'tote', phase: 'idle' };
    var rects = {
      tote: { x: 175, y: 120, w: 170, h: 148 },
      laptop: { x: 155, y: 117, w: 210, h: 132 },
      sleeve: { x: 208, y: 58, w: 104, h: 224 },
      canvas: { x: 172, y: 122, w: 176, h: 106 }
    };
    var defs = [];
    var cols = 6, rows = 5, pw = 40, ph = 36, ox = 140, oy = 80;
    for (var r = 0; r < rows; r++) for (var c = 0; c < cols; c++) {
      defs.push({
        px: ox + c * pw, py: oy + r * ph, c: c, r: r, w: pw - 2, h: ph - 2,
        bx: -(c * pw), by: -(r * ph),
        rad: 2 + Math.floor(Math.random() * 5),
        ir: ((Math.random() * 2 - 1) * 2.4).toFixed(1),
        sx: (Math.random() * 2 - 1) * 250, sy: (Math.random() * 2 - 1) * 165,
        rot: (Math.random() * 2 - 1) * 240,
        d1: (Math.random() * 0.14).toFixed(2), d2: (Math.random() * 0.2).toFixed(2), d3: (Math.random() * 0.15).toFixed(2)
      });
    }
    var layer = document.createElement('div');
    layer.style.cssText = 'position:absolute; inset:0;';
    stage.insertBefore(layer, stage.firstChild);
    var nodes = defs.map(function (p) {
      var el = document.createElement('div');
      el.className = 'sw-piece';
      el.style.cssText = 'left:' + p.px + 'px; top:' + p.py + 'px; width:' + p.w + 'px; height:' + p.h + 'px;';
      var inner = document.createElement('div');
      inner.className = 'sw-piece-in';
      inner.style.cssText = 'border-radius:' + p.rad + 'px; background-size:240px 180px; background-position:' + p.bx + 'px ' + p.by + 'px; box-shadow:inset 0 0 0 1px rgba(0,0,0,.15), 0 3px 8px -3px rgba(0,0,0,.5);';
      el.appendChild(inner);
      layer.appendChild(el);
      return { el: el, inner: inner, p: p };
    });
    function fabric() { return (data.fabrics || {})[state.fabric] || {}; }
    function paintPieces() {
      var img = fabric().waste;
      nodes.forEach(function (n) {
        n.inner.style.backgroundImage = img ? 'url(' + img + ')' : 'none';
        n.inner.style.backgroundColor = img ? '' : '#C9D6D9';
      });
    }
    function layout() {
      var rect = rects[state.product] || rects.tote;
      var cellW = rect.w / 6, cellH = rect.h / 5;
      nodes.forEach(function (n) {
        var p = n.p, tf = 'rotate(' + p.ir + 'deg)', op = 1, delay = '0s', dur = '.85s';
        if (state.phase === 'burst') {
          tf = 'translate(' + p.sx + 'px,' + p.sy + 'px) rotate(' + p.rot + 'deg)';
          delay = p.d1 + 's'; dur = '.6s';
        } else if (state.phase === 'form' || state.phase === 'done') {
          var tx = rect.x + p.c * cellW, ty = rect.y + p.r * cellH;
          tf = 'translate(' + (tx - p.px).toFixed(1) + 'px,' + (ty - p.py).toFixed(1) + 'px) rotate(0deg) scale(' + (cellW / 38).toFixed(3) + ',' + (cellH / 34).toFixed(3) + ')';
          delay = (state.phase === 'form' ? p.d2 : p.d3) + 's';
          dur = state.phase === 'form' ? '.9s' : '.45s';
          if (state.phase === 'done') op = 0;
        }
        n.el.style.transform = tf; n.el.style.opacity = op;
        n.el.style.transitionDelay = delay; n.el.style.transitionDuration = dur;
      });
    }
    function render() {
      var labels = { burst: 'BREAKING DOWN…', form: 'REASSEMBLING…', done: 'UPCYCLED ✓', idle: 'STAGE · SURPLUS FABRIC' };
      var lab = $('[data-super-game-label]', root);
      if (lab) { lab.textContent = labels[state.phase]; lab.style.color = state.phase === 'done' ? '#3B848B' : '#7A897E'; }
      var prodChip = $('[data-super-gproduct].is-on', root);
      var route = $('[data-super-game-route]', root);
      if (route) route.textContent = (fabric().name || '') + ' → ' + (prodChip ? prodChip.textContent.trim() : '');
      $$('[data-super-game-phase]', root).forEach(function (n) {
        var want = n.getAttribute('data-super-game-phase').split(',');
        var busy = state.phase === 'burst' || state.phase === 'form';
        var match = want.indexOf(state.phase) > -1 || (want.indexOf('busy') > -1 && busy);
        n.classList.toggle('super-hidden', !match);
      });
      $$('[data-super-game-result]', root).forEach(function (n) {
        var isOn = n.getAttribute('data-super-game-result') === state.product;
        n.classList.toggle('super-hidden', !isOn);
        if (isOn) {
          var img = $('img', n);
          var src = (fabric().products || {})[state.product];
          if (img) { if (src) { img.src = src; img.style.visibility = 'visible'; } else { img.style.visibility = 'hidden'; } }
        }
      });
      var doneLabels = { tote: 'One upcycled tote bag', laptop: 'One upcycled laptop bag', sleeve: 'One upcycled umbrella sleeve', canvas: 'One upcycled zip pouch' };
      var dl = $('[data-super-game-donelabel]', root);
      if (dl) dl.textContent = doneLabels[state.product] || '';
      layout();
    }
    var t1, t2, t3;
    function play() {
      if (state.phase !== 'idle') return;
      state.phase = 'burst'; render();
      t1 = setTimeout(function () { state.phase = 'form'; render(); }, 700);
      t2 = setTimeout(function () { state.phase = 'done'; render(); }, 1800);
    }
    $$('[data-super-fabric]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        clearTimeout(t1); clearTimeout(t2); clearTimeout(t3);
        $$('[data-super-fabric]', root).forEach(function (x) { x.classList.toggle('is-on', x === b); });
        state.fabric = b.getAttribute('data-super-fabric'); state.phase = 'idle';
        paintPieces(); render();
      });
    });
    $$('[data-super-gproduct]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        $$('[data-super-gproduct]', root).forEach(function (x) { x.classList.toggle('is-on', x === b); });
        state.product = b.getAttribute('data-super-gproduct');
        if (state.phase === 'done') {
          state.phase = 'form'; render();
          clearTimeout(t3);
          t3 = setTimeout(function () { state.phase = 'done'; render(); }, 550);
        } else render();
      });
    });
    $$('[data-super-play]', root).forEach(function (b) { on(b, 'click', play); });
    $$('[data-super-reset]', root).forEach(function (b) {
      on(b, 'click', function () { clearTimeout(t1); clearTimeout(t2); clearTimeout(t3); state.phase = 'idle'; render(); });
    });
    var f0 = $('[data-super-fabric]', root); if (f0) f0.classList.add('is-on');
    var p0 = $('[data-super-gproduct]', root); if (p0) p0.classList.add('is-on');
    state.product = p0 ? p0.getAttribute('data-super-gproduct') : 'tote';
    paintPieces(); render();
  }

  /* ---------------- boot ---------------- */
  function boot() {
    document.body.setAttribute('data-super-mode', currentMode());
    $$('[data-super-mode-set]').forEach(function (b) {
      b.classList.toggle('is-on', b.getAttribute('data-super-mode-set') === currentMode());
      b.addEventListener('click', function () { setMode(b.getAttribute('data-super-mode-set')); });
    });
    CartUI.drawer = $('#super-cart-drawer');
    if (CartUI.drawer) {
      $$('[data-super-cart-open]').forEach(function (b) { on(b, 'click', function () { CartUI.open(); }); });
      $$('[data-super-cart-close]', CartUI.drawer).forEach(function (b) { on(b, 'click', function () { CartUI.close(); }); });
      CartUI.drawer.addEventListener('click', function (e) { if (e.target === CartUI.drawer) CartUI.close(); });
      CartUI.drawer.addEventListener('click', function (e) {
        var b = e.target.closest ? e.target.closest('button[data-line]') : null;
        if (!b) return;
        if (b.getAttribute('data-remove')) CartUI.change(b.getAttribute('data-line'), 0);
        else {
          var qty = parseInt(b.parentNode.querySelector('span').textContent, 10) || 1;
          CartUI.change(b.getAttribute('data-line'), qty + Number(b.getAttribute('data-delta')));
        }
      });
      CartUI.refresh();
    }
    document.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-super-add], [data-quick-add]') : null;
      if (!b) return;
      var vid = b.getAttribute('data-variant-id');
      if (!vid) { window.location.href = b.getAttribute('data-fallback-url') || '/collections/all'; return; }
      e.preventDefault();
      var qv = document.getElementById('super-quick-view');
      if (qv) qv.classList.remove('is-open');
      CartUI.add([{ id: Number(vid), quantity: Number(b.getAttribute('data-quantity') || 1) }]);
    });
    initFx(); initShop(); initQuick(); initBatch(); initAiSection();
    initCustomizer(); initRunFlow(); initModals(); initGame();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
